import { render, staticRenderFns } from "./CompanyDepartmentListPage.vue?vue&type=template&id=3b64dabb&scoped=true&lang=pug&"
import script from "./CompanyDepartmentListPage.vue?vue&type=script&lang=js&"
export * from "./CompanyDepartmentListPage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyDepartmentListPage.vue?vue&type=style&index=0&id=3b64dabb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64dabb",
  null
  
)

export default component.exports